<template>
    <div>
        <OrderDataPreviewsDialog
            :is-open="orderDataPreviewsDialog"
            :previews="selectedOrderPreviews"
            @on-close="closeOrderDataPreviewsDialog"
        />
        <v-data-table
            :headers="headers"
            :items="orders || []"
            :items-per-page="-1"
            hide-default-footer
            class="elevation-0"
        >
            <template #[`item.preview`]="{item}">
                <div>
                    <img
                        v-if="item.previews.length"
                        :src="getPreviewImageUrl(item.previews[0])"
                        width="100px"
                        height="60px"
                        alt="Podgląd zamówienia"
                        @click="openOrderDataPreviewsDialog(item.previews)"
                    >
                    <i v-else>Brak podglądu</i>
                </div>
            </template>
            <template #[`item.verboseNameOrderType`]="{item}">
                <div>
                    {{ formatOrderType(item.verboseNameOrderType) }}
                </div>
            </template>
            <template #[`item.actions`]="{item}">
                <v-btn
                    :color="item.isSent ? 'success' : 'primary'"
                    outlined
                    data-sentry-label="Nadaj"
                    :disabled="item.isSent || item.sendingBlocked"
                    @click="showSendings(item.orderNumber)"
                >
                    {{ item.isSent ? 'Nadane' : 'Nadaj' }}
                </v-btn>
            </template>
        </v-data-table>
        <v-row no-gutters justify="space-between">
            <v-col cols="auto">
                <v-btn
                    color="primary"
                    outlined
                    class="mt-3 mb-2"
                    data-sentry-label="Wstecz"
                    @click="showPreviousStep"
                >
                    Wstecz
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { apiConfig } from '@/config'
import { errorHandler } from '@/utils/errorHandler'
import { EventBus } from '@/utils/eventBus'
import OrderDataPreviewsDialog from './OrderDataPreviewsDialog.vue'

export default {
    name: 'OrderData',

    components: {
        OrderDataPreviewsDialog
    },

    props: {
        reportData: {
            type: Object,
            default: null
        },
    },

    data() {
        return {
            orders: null,
            headers: [
                { text: 'podgląd', value: 'preview', 'align': 'center', sortable: false },
                { text: 'numer zamówienia', value: 'orderNumber', 'align': 'center', sortable: false },
                { text: 'produkt', value: 'productName', 'align': 'center', sortable: false },
                { text: 'nakład', value: 'amount', 'align': 'center', sortable: false },
                { text: 'wzór', value: 'orderTemplatesToRead', 'align': 'center', sortable: false },
                { text: 'rodzaj', value: 'verboseNameOrderType', 'align': 'center', sortable: false },
                { text: '', value: 'actions', sortable: false, 'align': 'center' },
            ],
            selectedOrderPreviews: null,
            orderDataPreviewsDialog: false
        }
    },

    watch: {
        reportData() {
            this.getOrders()
        }
    },

    mounted() {
        this.getOrders()
    },

    methods: {
        showPreviousStep() {
            this.$emit('show-previous-step')
        },

        showSendings(orderNumber) {
            this.$emit('order-loading', true)
            this.$emit('show-next-step')
            EventBus.$emit('getOrder', orderNumber)
        },

        async getOrders() {
            return await this.$store.dispatch('reports/getOrdersOfJob', {
                primaryNumber: this.reportData.objectNumber,
                plateNumber: this.reportData.plateNumber
            })
                .then(response => {
                    this.orders = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.$emit('order-loading')
                })
        },

        getPreviewImageUrl(image) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            return `${mediaRoot}${image.path}`
        },

        openOrderDataPreviewsDialog(previews) {
            this.selectedOrderPreviews = previews
            this.orderDataPreviewsDialog = true
        },

        closeOrderDataPreviewsDialog() {
            this.orderDataPreviewsDialog = false
        },

        formatOrderType(value) {
            if (!value) return ''

            return value.replace(' ', '\n')
        }
    }
}

</script>